module.exports = __webpack_public_path__ + "img/microchip.cef3091c.jpg";